import classNames from "classnames";

import strings from "rivals/components/shared/Form/BillingInformation/AddressVerificationModal/strings";
import { extractAddressFromCandidate } from "rivals/shared/utils/smartyStreets";
import styles from "./ModalBody.module.scss";
import Suggestion from "./Suggestion";
import type { Props } from "./types";

const { correctableState, errorState } = strings;

const ModalBody = ({
  addressCandidate,
  formAddress,
  isValidAddress
}: Props): JSX.Element => {
  if (!isValidAddress) {
    // address is completely invalid (see states on AddressVerificationModal/index.tsx)
    return (
      <blockquote className={classNames(styles.block, styles.error)}>
        <h5 className={styles.blockTitle}>{errorState.blockTitle}</h5>
        <p className={styles.blockDescription}>{errorState.blockDescription}</p>
      </blockquote>
    );
  }

  // address is invalid but correctable (see states on AddressVerificationModal/index.tsx)
  const suggestedAlternative = extractAddressFromCandidate(addressCandidate);
  return (
    <>
      <blockquote className={styles.block}>
        <h5 className={styles.blockTitle}>{correctableState.blockTitle}</h5>
        <p className={styles.blockDescription}>
          {correctableState.blockDescription}
        </p>
      </blockquote>
      <Suggestion
        address={formAddress}
        disabled
        isChecked={false}
        title={correctableState.enteredAddress}
      />
      <Suggestion
        address={suggestedAlternative}
        analysisFootnotes={addressCandidate?.analysis.footnotes}
        isChecked
        title={correctableState.suggestedAddress}
      />
    </>
  );
};

export default ModalBody;
